import { SBTranslate } from "i18n";
import { IDistributionOrder } from "domain/Inventory/Models/IDistributionOrder";
import { IDistributionOrderSummary } from "domain/Inventory/Models/IDistributionOrderSummary";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SBSummarization from "views/Commons/SBSummarization";
import { IDistributionOrderSummarizationProps } from "./models/IDistributionOrderSummarizationProps";

export const DistributionOrderSummarization = ({
	summary,
	selectedItems,
}: IDistributionOrderSummarizationProps) => {
	const { i18n } = useTranslation();

	const sum = (list: IDistributionOrder[], field: keyof IDistributionOrder) =>
		list.reduce((acc, item) => acc + ((item[field] as number) || 0), 0);

	const hasSelected = !!selectedItems && selectedItems.length > 0;

	const summarizations = useMemo(
		() => [
			{
				name: SBTranslate("quantity"),
				tip: SBTranslate("quantity"),
				icon: "package",
				color: "darkPurple",
				value: summary?.totalQuantity ?? 0,
				selectedItems: hasSelected
					? sum(selectedItems!, "quantity")
					: undefined,
			},
		],
		[summary, selectedItems, i18n.language],
	);

	if (!summary || summary.totalCount === 0) return null;

	return <SBSummarization items={summarizations} withShadow />;
};
